<template>
  <div>
    <v-data-table :headers="headers" :page.sync="page" :items="seats" hide-default-footer @page-count="pageCount = $event">
      <template v-slot:body="{ items }">
        <tbody>
          <RemoteAgencySeatRow v-for="(item, idx) in items" :key="`ras + ${idx}`" :user="item" :host-type="hostType" :total-users="items.length"></RemoteAgencySeatRow>
        </tbody>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination v-model="page" color="#004C97" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
import RemoteAgencySeatRow from './RemoteAgencySeatRow';
import { mapGetters } from 'vuex';

export default {
  name: 'RemoteAgencySeatsTable',
  components: {
    RemoteAgencySeatRow
  },
  props: {
    hostType: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      page: 1,
      pageCount: 0,
      headers: [
        { text: 'First', class: 'caption font-weight-bold', width: '18%' },
        { text: 'Last', class: 'caption font-weight-bold', width: '18%' },
        { text: 'Email', class: 'caption font-weight-bold', width: '28%' },
        { text: 'Online Username', class: 'caption font-weight-bold', width: '25%' },
        { text: 'Delete', class: 'caption font-weight-bold' }
      ]
    };
  },
  computed: {
    ...mapGetters(['getVisibleRemoteAgencySeats']),
    seats () {
      return this.getVisibleRemoteAgencySeats;
    }
  }
};
</script>

<style scoped>

</style>
